var map = {
	"./excel.png": 5670,
	"./gif.png": 3194,
	"./json.png": 336,
	"./mp3.png": 1448,
	"./notFound.png": 7897,
	"./pdf.png": 7022,
	"./ppt.png": 9219,
	"./rar.png": 687,
	"./svg.png": 5966,
	"./txt.png": 2729,
	"./word.png": 7304,
	"./xlsx.png": 8784,
	"./zip.png": 8055
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 919;